import _styled from "@emotion/styled/base";
import { RowHeader } from '../RowHeader';
export var RowSubHeader = /*#__PURE__*/_styled(RowHeader, true ? {
  target: "efoodvf0"
} : {
  target: "efoodvf0",
  label: "RowSubHeader"
})(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textRegularSmall;
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.pSmall.css;
}, ";}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{", function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.h6.css;
}, ";margin-left:24px;}" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvVGFibGVQcmljaW5nL1Jvd1N1YkhlYWRlci9Sb3dTdWJIZWFkZXIudmlld3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSTZDIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvVGFibGVQcmljaW5nL1Jvd1N1YkhlYWRlci9Sb3dTdWJIZWFkZXIudmlld3MudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuaW1wb3J0IHsgUm93SGVhZGVyIH0gZnJvbSAnLi4vUm93SGVhZGVyJ1xuXG5leHBvcnQgY29uc3QgUm93U3ViSGVhZGVyID0gc3R5bGVkKFJvd0hlYWRlcilgXG4gICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudHlwb2dyYXBoeS50ZXh0UmVndWxhclNtYWxsfTtcbiAgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5icmVha3BvaW50cy51cChgc21gKX0ge1xuICAgICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudHlwb2dyYXBoeS5wU21hbGwuY3NzfTtcbiAgfVxuICAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmJyZWFrcG9pbnRzLnVwKGBsZ2ApfSB7XG4gICAgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50eXBvZ3JhcGh5Lmg2LmNzc307XG4gICAgbWFyZ2luLWxlZnQ6IDI0cHg7XG4gIH1cbmBcbiJdfQ== */"));